import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import StakeholderGroupsPageQuery$parameters from '@atlassian/jira-relay/src/__generated__/StakeholderGroupsPageQuery.graphql';

export const communicationsStakeholderGroupsEntrypoint = createEntryPoint({
	root: JSResourceForInteraction(() =>
		import(
			/* webpackChunkName: "async-communications-stakeholder-groups-entrypoint" */ './src/ui/StakeholderGroupsPage'
		).then((module) => module.StakeholderGroupsPage),
	),
	getPreloadProps: () => {
		return {
			queries: {
				StakeholderGroupsPageQuery: {
					parameters: StakeholderGroupsPageQuery$parameters,
					variables: { first: 30 },
					options: {
						fetchPolicy: 'store-and-network' as const,
					},
				},
			},
		};
	},
});
